import { IRegistrationState } from './state';

export const isValidatingInfo = (state: { registration: IRegistrationState }): boolean => state.registration.isFetching;


